/* 
  Accessibility enhancements for header menu items
  This script updates the ARIA Expanded attributes for header menu items to improve accessibility
*/

const navEvents = ['click', 'mouseenter', 'mouseleave'];

/**
 * Updates ARIA attributes for header menu items for accessibility.
 * @param {Object} nav - Navigation selectors object from themeObject.selectors.nav
 * @param {NodeList} nav.headerMenuItems - NodeList of menu items to update
 * @param {string} nav.headerMenuLink - Selector for the menu link inside each menu item
 * @param {string} nav.headerDropdownTarget - Selector for the dropdown element inside each menu item
 * @param {string} nav.headerMenuItemIsOpen - Class name indicating an open menu item
 */
const updateHeaderMenuAria = nav => {
  const { headerMenuItems, headerMenuLink, headerDropdownTarget, headerMenuItemIsOpen } = nav;
  if (!headerMenuItems) return;
  headerMenuItems.forEach(menuItem => {
    const trigger = menuItem.querySelector(headerMenuLink);
    const dropdown = menuItem.querySelector(headerDropdownTarget);
    if (!trigger) return;
    trigger.setAttribute('aria-expanded', menuItem.classList.contains(headerMenuItemIsOpen));
    if (dropdown?.id) trigger.setAttribute('aria-controls', dropdown.id);
  });
};

/**
 * Registers event listeners for navigation accessibility.
 * @param {Object} nav - Navigation selectors object from themeObject.selectors.nav
 * @param {string} nav.headerMenuItemsSelector - Selector string for menu items (used with closest)
 */
const registerNavEvents = nav => {
  navEvents.forEach(event =>
    document.addEventListener(event, e => {
      if (
        event === 'click' ||
        e.target.closest(nav.headerMenuItemsSelector)
      ) {
        setTimeout(() => updateHeaderMenuAria(nav), 10);
      }
    }, true)
  );
};

/**
 * Initializes navigation accessibility enhancements.
 * No arguments. Grabs nav selectors from themeObject.
 */
const initNavigationAccessibility = () => {
  const nav = themeObject.selectors.nav;
  registerNavEvents(nav);
  updateHeaderMenuAria(nav);
};

document.addEventListener('DOMContentLoaded', initNavigationAccessibility);
